import httpService from '@/utils/http-service'

const module = 'admin'
const controller = 'admin'

export function readme() {
	return httpService.request({
		url: `${module}/${controller}/readme`
	})
}